import type { ComponentType } from 'react';
import SubfolderCard from './SubfolderCard';
import SubfolderCardContainer, { OwnProps } from './SubfolderCard.container';

export default SubfolderCardContainer(SubfolderCard) as ComponentType<
  OwnProps
>;
